/**
 * Met à jour le remplissage visuel des sliders (CSS variables)
 */
export function updateSliderFill(slider) {
    if (!slider) return;
    const min = parseFloat(slider.min), max = parseFloat(slider.max), value = parseFloat(slider.value);
    let percentage = ((value - min) / (max - min)) * 100;
    if (isNaN(percentage) || !isFinite(percentage)) {
        percentage = (slider.id.includes('volume')) ? 20 : 0;
    }
    slider.style.setProperty('--value-percent', `${percentage}%`);
}


/**
 * Formate le temps en MM:SS
 */
export const formatTime = (t) => {
    if (isNaN(t) || t === Infinity) return "00:00";
    const m = Math.floor(t / 60), s = Math.floor(t % 60);
    return `${m < 10 ? "0" : ""}${m}:${s < 10 ? "0" : ""}${s}`;
};

/**
 * Met à jour la barre de progression et l'affichage du temps
 * Retourne la nouvelle valeur de maxSeenDuration
 */
export function updateTimelineAndDisplay(videoElement, timelineEl, timeDisplayEl, currentMaxDuration) {
    if (!timelineEl || !timeDisplayEl || !videoElement) return currentMaxDuration;

    const duration = videoElement.duration;
    const currentTime = videoElement.currentTime;
    const isLive = isNaN(duration) || duration === Infinity;
    
    const currentDisplayDuration = isLive ? currentTime : duration;
    
    // On calcule le nouveau maximum
    let newMax = currentMaxDuration;
    if (currentDisplayDuration > currentMaxDuration) {
        newMax = currentDisplayDuration;
    }

    const parentSliderContainer = timelineEl.closest('.slider-container');
    if (parentSliderContainer) parentSliderContainer.style.display = 'block';
    else timelineEl.style.display = 'block';

    timelineEl.max = newMax;
    timelineEl.value = currentTime;
    timeDisplayEl.textContent = `⏱ ${formatTime(currentTime)} / ${formatTime(newMax)}`;
    
    updateSliderFill(timelineEl);
    
    return newMax; // On retourne la valeur pour mettre à jour la variable locale
}